<template>
  <div class="account-page login-page">
    <!-- bg -->
    <div class="bg" ref="videoBg" v-if="!isMobile">
      <video
        :id="videoId"
        class="video video-js"
        crossOrigin="anonymous"
        playsinline
        controls
        muted
      >
        <source :src="videoUrl" />
      </video>
      <!--<div class="cover" v-if="uploadedVideo">-->
      <!--<img src="/media/trade_cover.png" alt="" />-->
      <!--</div>-->
      <div class="mask"></div>
    </div>
    <!-- header -->
    <div class="header">
      <div class="info">
        <img class="logo" v-if="isMobile" :src="require('@/assets/logo.jpg')" alt="logo" @click="gotoIndex">
      </div>
      <div class="back">
        <el-button
          v-if="!isMobile"
          type="primary"
          size="small"
          @click="gotoIndex"
          v-text="'< 返回首页'"
        ></el-button>
        <el-button
          v-else
          circle
          size="mini"
          type="primary"
          icon="el-icon-arrow-left"
          @click="gotoIndex"
        ></el-button>
      </div>
    </div>
    <!-- form wrapper -->
    <div class="form-wrapper">
      <h1 class="form-header">用户登录</h1>
      <el-alert class="error" v-if="error" type="error" :closable="false">{{
        error
      }}</el-alert>
      <!-- form -->
      <el-form
        ref="form"
        class="form"
        :model="form"
        :rules="rules"
        label-position="top"
        :hide-required-asterisk="true"
      >
        <el-form-item label="用户名" prop="userName">
          <el-input
            v-model="form.userName"
            suffix-icon="el-icon-user"
            placeholder="请输入用户名"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="pwd">
          <el-input
            v-model="form.pwd"
            clearable
            show-password
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item class="no-border submit-wrapper">
          <el-button
            type="primary"
            class="submit-button"
            @click="submit"
            :loading="loading"
            >登录</el-button
          >
          <el-button
            type="text"
            class="reset-crypto-button"
          >
            <a :href="resetCryptoUrl" target="_blank">找回密码</a>
          </el-button
          >
        </el-form-item>
      </el-form>
      <!-- register -->
      <choose-account label="尚未开通账号，立即注册"></choose-account>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import VideoJs from "video.js";
import "video.js/dist/video-js.min.css";
import { gotoIndex, doLogin } from "@/libs/tools";
import ChooseAccount from "@/components/ChooseAccountType";

let videoIndex = 0;

export default {
  components: {
    "choose-account": ChooseAccount
  },
  data() {
    return {
      videoId: "",
      player: null,
      form: {
        // userName: "18926418302",
        // pwd: "123456"
        userName: "",
        pwd: ""
      },
      rules: {
        userName: {
          required: true,
          message: "请输入用户名",
          triangle: "change"
        },
        pwd: {
          required: true,
          message: "请输入密码",
          triangle: "change"
        }
      },
      error: "",
      loading: false
    };
  },
  computed: {
    ...mapGetters(["isMobile"]),
    videoUrl() {
      const screenWidth = window.innerWidth;
      return `${process.env.BASE_URL || "./"}media/trade_${screenWidth <= 1920 ? "large" : "large"}.mp4`;
    },
    resetCryptoUrl() {
      return window.global.manageResetCrypto;
    }
  },
  created() {
    videoIndex += 1;
    this.videoId = `video_${videoIndex}`;
  },
  mounted() {
    !this.isMobile && this.initPlayer();
  },
  methods: {
    ...mapMutations(["setToken", "setUsername", "setRegisterMode"]),

    initPlayer() {
      const options = {
        bigPlayButton: false,
        controlBar: false,
        loop: false
      };
      this.player = VideoJs(this.videoId, options);
      this.player.play();
    },

    submit() {
      const param = { ...this.form };
      doLogin(param, res => {
        this.error = res.code === 0 ? "" : res.msg;
      });
      // this.$refs.form.validate(valid => {
      //   if (!valid) return;
      //
      //   const param = { ...this.form };
      //   this.loading = true;
      //   this.$request.account_login(param).then(res => {
      //     const { code = -1, msg = "" } = res;
      //
      //     this.loading = false;
      //
      //     if (code !== 0) {
      //       this.error = msg;
      //       return;
      //     }
      //
      //     const { userName, userToken, registerMode } = res;
      //     this.error = "";
      //     const userinfo = {
      //       userName,
      //       registerMode
      //     };
      //     localStorage.set("token", userToken);
      //     localStorage.set("userinfo", userinfo);
      //     this.setToken(userToken);
      //     this.setUsername(userName);
      //     this.setRegisterMode(registerMode);
      //
      //     gotoIndex();
      //   });
      // });
    },

    gotoIndex() {
      gotoIndex();
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/scss/pages/account.scss";
</style>
